export const FLIGHT_FROZEN_PRICES_TITLE = "Frozen Prices (Flights)";
export const FLIGHT_FROZEN_PRICES_SUBTITLE = "Terms and Conditions";
